import { motion } from "framer-motion";

/**
 * Animated, theme-aware global-search mockup. A search field with a "typed"
 * query and result rows that stagger in. Replaces the search screenshots.
 */

const RESULTS = [
  { letter: "R", name: "React docs: useEffect", domain: "react.dev", color: "#3b82f6" },
  { letter: "M", name: "Color contrast guide", domain: "web.dev", color: "#10b981" },
  { letter: "S", name: "System design primer", domain: "github.com", color: "#f59e0b" },
];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.1, delayChildren: 0.35 } },
};
const row = {
  hidden: { opacity: 0, x: -12 },
  show: { opacity: 1, x: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

export const SearchMock = ({ className = "" }) => {
  return (
    <motion.div
      className={`obm-mock obm-mock--search ${className}`}
      initial={false}
      animate="show"
    >
      <div className="obm-mock__chrome">
        <span className="obm-mock__dot" style={{ background: "#ef4444" }} />
        <span className="obm-mock__dot" style={{ background: "#f59e0b" }} />
        <span className="obm-mock__dot" style={{ background: "#10b981" }} />
        <div className="obm-mock__omnibox">my.onbookmarks.com</div>
      </div>

      <div className="obm-mock__body">
        <div className="obm-mock__searchbar">
          <i className="bi bi-search" />
          <motion.span
            className="obm-mock__typed"
            initial={false}
            animate={{ width: "auto" }}
          >
            color contrast
          </motion.span>
          <span className="obm-mock__caret" />
          <kbd className="obm-mock__kbd">⌘K</kbd>
        </div>

        <motion.div
          className="obm-mock__list mt-3"
          variants={container}
          initial={false}
          animate="show"
        >
          {RESULTS.map((r) => (
            <motion.div className="obm-mock__item" key={r.name} variants={row}>
              <span className="obm-mock__fav" style={{ background: r.color }}>
                {r.letter}
              </span>
              <div className="obm-mock__meta">
                <span className="obm-mock__title">{r.name}</span>
                <span className="obm-mock__domain">{r.domain}</span>
              </div>
              <i className="bi bi-arrow-return-left obm-mock__enter" />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </motion.div>
  );
};

export default SearchMock;
